import { render, staticRenderFns } from "./AiContentReport.vue?vue&type=template&id=86d7acbc"
import script from "./AiContentReport.vue?vue&type=script&lang=js"
export * from "./AiContentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports